import { Box, Typography, useTheme } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import Grid from '@mui/material/Grid2';
import DataTable from 'components/Common/DataTable';
import { ColumnDef } from '@tanstack/react-table';
import Input from 'components/Common/Input';
import Radio from 'components/Common/Radio';
import Switch from 'components/Common/Switch';
import TimePicker from 'components/Common/TimePicker';
import Select from 'components/Common/Select';

export default function StoreInfo() {
  const theme = useTheme();
  const { control, watch } = useFormContext();
  const isPhysicalLocation = watch('agent.physical_location_exists');

  return (
    <Box
      bgcolor={theme.palette.background.paper}
      sx={{ border: '1px solid #F3F3F3' }}
      padding='24px'
      borderRadius='4px'
    >
      <Radio
        name='agent.physical_location_exists'
        label='Is Physical Location?'
        control={control}
        options={[
          { label: 'Yes', value: true },
          { label: 'No', value: false }
        ]}
      />
      <Grid container spacing='16px' marginY='24px'>
        {isPhysicalLocation && (
          <>
            <Grid size={4}>
              <Input name='agent.location_name' label='Location Name' control={control} fullWidth />
            </Grid>
            <Grid size={4}>
              <Input name='agent.business_address' label='Business Address' control={control} fullWidth />
            </Grid>
          </>
        )}
        <Grid size={4}>
          <Select
            name='agent.industry'
            label='Industry'
            control={control}
            options={[
              { label: 'Technology', value: 'technology' },
              { label: 'Healthcare', value: 'healthcare' },
              { label: 'Finance', value: 'finance' },
              { label: 'Manufacturing', value: 'manufacturing' },
              { label: 'Energy', value: 'energy' },
              { label: 'Solar', value: 'solar' },
              { label: 'Retail', value: 'retail' },
              { label: 'Real Estate', value: 'real_estate' },
              { label: 'Recruitment', value: 'recruitment' },
              { label: 'Car Dealership', value: 'car_dealership' },
              {
                label: 'Transportation and logistics',
                value: 'transportation_and_logistics'
              },
              { label: 'Mortgage', value: 'mortgage' },
              { label: 'Hospitality', value: 'hospitality' },
              { label: 'Insurance', value: 'insurance' },
              { label: 'Agriculture', value: 'agriculture' },
              {
                label: 'Entertainment and Media',
                value: 'entertainment_and_media'
              },
              { label: 'Education', value: 'education' },
              {
                label: 'Tourism and hospitality',
                value: 'tourism_and_hospitality'
              },
              { label: 'Automotive', value: 'automotive' },
              { label: 'Telecommunications', value: 'telecommunications' },
              { label: 'Construction', value: 'construction' },
              { label: 'Others', value: 'others' }
            ]}
          />
        </Grid>
      </Grid>

      <Typography variant='h6' marginBottom='24px'>
        Business Hours
      </Typography>
      <DataTable data={daysOfWeek} columns={columns(control)} isHeaderSticky={true} />
    </Box>
  );
}

const columns = (control: any): ColumnDef<any>[] => [
  {
    header: 'Day',
    accessorKey: 'label',
    cell: (info) => (
      <Box display='flex' gap={1}>
        <Typography>{info.row.original.label}</Typography>
      </Box>
    )
  },
  {
    header: 'Status',
    cell: (info) => (
      <Box display='flex' gap={1}>
        <Switch name={`agent.business_hours.[${info.row.original.value}].open`} control={control} />
      </Box>
    )
  },

  {
    header: 'Time',
    cell: (info) => (
      <Box display='flex' gap={1}>
        <TimePicker name={`agent.business_hours.[${info.row.original.value}].from_time`} control={control} />
        <TimePicker name={`agent.business_hours.[${info.row.original.value}].to_time`} control={control} />
      </Box>
    )
  }
];

const daysOfWeek = [
  { label: 'Monday', value: 'monday' },
  { label: 'Tuesday', value: 'tuesday' },
  { label: 'Wednesday', value: 'wednesday' },
  { label: 'Thursday', value: 'thursday' },
  { label: 'Friday', value: 'friday' },
  { label: 'Saturday', value: 'saturday' },
  { label: 'Sunday', value: 'sunday' }
];
